import React from "react";
import SubscribeBannerView from "./SubscribeBannerView";
import RewardedAdBannerView from "./RewardedAdBannerView";
import PurchaseBannerView from "./PurchaseBannerView";
import PropTypes from "prop-types";
import AppContext from "../contexts/AppContext";

export default class BannerView extends React.Component {

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.hidden !== this.props.hidden
      || nextProps.isOnScreen !== this.props.isOnScreen;
  }

  render() {
    if (this.props.hidden) {
      return null;
    }

    if (window.clientConfig.features.isSubscribeModel) {
      return <SubscribeBannerView isOnScreen={this.props.isOnScreen} />;
    } else if (window.clientConfig.features.isRewardedAdModel && this.state.rewardedAdIsLoaded) {
      return <RewardedAdBannerView isOnScreen={this.props.isOnScreen} />;
    } else if (window.clientConfig.features.isPurchaseModel) {
      return <PurchaseBannerView isOnScreen={this.props.isOnScreen} />;
    }
  }
}

BannerView.contextType = AppContext;
BannerView.propTypes = {
  hidden: PropTypes.bool.isRequired,
  isOnScreen: PropTypes.bool.isRequired,
};